module.exports = __webpack_public_path__ + "media/images/emoticons/japanesetea-21270ed94a413704705f1452d2caa6d5.gif";